import React, {useEffect, useState} from "react";
import { getUserEducations, removeUserEducationById } from "../../service";
import {getUserStorage} from "../../units";
import {Link, useHistory} from "react-router-dom";
import Empty from "../../components/empty";
import {EducationData} from "../types";
import useRefresh from "../../routers/useRefresh";
import {useLoading} from "../../components/loading/LoadingProvider";

function Education(){

    const [lists,setLists] = useState<Array<EducationData>>([])
    const userData = getUserStorage()
    const his = useHistory()
    const { current } = useRefresh()

    useEffect(() => {
        if(userData){
            getUserEducations({
                userId:userData.id
            }).then(res => {
                if(res.code === 1){
                    setLists(res.data)
                }
            })
        }

    },[current])



    const DetailHandle = (id:string) => {
        his.push(`/user/info/education/${ id }/modify`)
    }

    return <div className="job-detail education">
        <div className="wrapper">
            <div className="flex">
                <h1>教育经历</h1>
                <Link to={ '/user/info/education/add' } className="common-more iconfont">&#xe609;</Link>
            </div>
            <div className="lists">
                {
                    lists.length > 0 ?  lists.map((item,index) =>{
                        return <div className="item" key={index} onClick={ () =>  DetailHandle(item.id)}>
                            <div className="flex">
                                <h2>{ item.school }</h2>
                                <p className="iconfont" style={{ opacity:.65 }}>&#xe608;</p>
                            </div>
                            <p className="d">{ item.start.replace(/-/g,'.') } - { item.end.replace(/-/g,'.') } · { item.subject }</p>
                            <p className="x">学历：{ item.degree }</p>
                        </div>
                    }) : <Empty>
                        暂无教育经历
                    </Empty>
                }
            </div>
        </div>
    </div>
}

export default  Education
